<template>
  <div class="chaperonage">
    <div class="img-text">
      <div class="picture">
        <img src="@/assets/robot_1.png">
      </div>
      <div class="text">
        <h2>Emotional<br /> robot</h2>
        <p>Emotional companion robot based on brain-inspired intelligence</p>

      </div>
    </div>
    <div class="img-text reversal">
      <div class="picture">
        <img src="@/assets/guofa1.png">
      </div>
      <div class="text">
        <h2>Smart<br /> Wearables</h2>
        <p>Robot control training system based on human body data collection.</p>

      </div>
    </div>
    <div class="img-text">
      <div class="picture">
        <img src="@/assets/guofa2.png">
      </div>
      <div class="text">
        <h2>Affective<br /> Empowering AI</h2>
        <p>Emotional Expression with Human-Machine Collaboration</p>
      </div>
    </div>
    <div class="muscle">
        <img src="@/assets/inter_3.gif">
      </div>
  </div>
</template>

<script>

  export default {
    name: "chaperonage.vue"
  }
</script>

<style scoped>

  .muscle {
    line-height: 0;
    position: relative;
  }

  .muscle img {
    width: 100%;
  }

  .img-text {
    display: flex;
    box-sizing: border-box;
    padding-top: 192px;
  }

  .img-text .picture {
    display: flex;
    width: 57%;
    align-items: center;
  }

  .img-text .picture img {
    width: 100%;
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
  }

  .img-text .text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 100px;
  }

  .img-text h2 {
    margin-bottom: 40px;
    font-weight: 700;
    font-size: 52px;
    line-height: 69px;
  }

  .img-text p {
    width: 390px;
    font-size: 28px;
    line-height: 60px;
  }

  .reversal {
    flex-direction: row-reverse;
  }

  .reversal .picture img {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
  }

  .reversal .text {
    margin-right: 48px;
    margin-left: 0;
  }

</style>
